import { ElementTransformation } from "../TransformationMatrix";

export class RouletteSlot {
  private container: HTMLElement;
  private slotAngle: number;
  private parent: HTMLElement;

  constructor(slotAngle: number) {
    this.slotAngle = slotAngle;
    this.container = document.createElement("div");
    this.container.classList.add("roulette-slot");
    this.container.style.transform = `translate(-50%, -100%) rotateZ(
      ${slotAngle}deg)`;
    this.slotAngle = slotAngle;
  }

  public appendTo(parent: HTMLElement): void {
    this.parent = parent;
    parent.appendChild(this.container);
  }

  public appendChild(content: Node): void {
    this.container.appendChild(content);
  }

  public bringToTop(): void {
    this.container.style.zIndex = "100";
  }

  public bringToBack(): void {
    this.container.style.zIndex = "0";
  }

  get element(): HTMLElement {
    return this.container;
  }

  get absoluteTransformation(): ElementTransformation {
    const transformation = new ElementTransformation(this.parent);
    transformation.updateWith(this.element)
    return transformation;
  }
}